<template>
  <component :is="hasCardLink ? 'a' : 'div'" v-if="blok && (visibility || isEditMode)" ref="card" class="masonry-card" :style="[cardStyle]" :class="{ 'masonry-card-link': hasCardLink }" :href="blok?.buttons?.length > 0 ? undefined : cardLink" :target="blok?.link?.target || '_self'" :title="blok.title" :aria-label="blok.title" :data-color="blok.card_color || '#FFF'" :data-has-icon="blok?.icon?.filename?.length > 0" :data-theme="blok.card_theme || 'dark'" @click="onCardClick($event)">
    <span v-if="props.blok?.personalise && isEditMode" class="personalisation-tooltip" aria-hidden="true" v-text="`Personalised: ${props.blok?.personalise}`"></span>
    <div v-if="blok.icon?.filename" class="masonry-card-icon">
      <img :src="optimizeImage(blok.icon.filename)" :alt="`${blok.title} Icon`" />
    </div>
    <div class="masonry-card-body">
      <div class="masonry-card-content">
        <h3 class="masonry-card-title">{{ blok.title }}</h3>
        <div v-if="hasRichTextContent(blok.description)" class="masonry-card-description">
          <StoryblokRichText :resolvers="richtextResolvers" :doc="blok.description" />
        </div>
        <div v-if="blok?.buttons?.length > 0" class="masonry-card-buttons">
          <StoryblokComponent v-for="button in blok.buttons" :key="button._uid" :blok="button" />
        </div>
      </div>
    </div>
    <div v-if="blok.image?.filename" class="masonry-card-image">
      <img :src="optimizeImage(blok.image.filename)" :alt="`${blok.title} Image`" />
    </div>
  </component>
</template>

<script setup lang="ts">
  import { hasRichTextContent, optimizeImage, richtextResolvers } from "#imports";
  const props = defineProps({
    blok: Object,
  });

  const route = useRoute();
  const isEditMode = route.fullPath.includes("_storyblok");

  const visibility = ref(true);
  const card = ref();
  const { checkPersonalisedVisibility } = usePersonalisation();

  const cardStyle = computed(() => {
    return {
      background: props.blok?.card_color || undefined,
    };
  });

  const hasCardLink = computed(() => {
    if ([props?.blok?.link?.url, props?.blok?.link?.cached_url].join("").trim().length === 0) return false;
    if (props.blok?.buttons?.length > 0) return false;

    return true;
  });

  const cardLink: Ref<string | undefined> = computed(() => {
    if (props.blok?.buttons?.length > 0) {
      return getLinkFieldUrl(props.blok?.buttons[0]?.url);
    }

    const link = getLinkFieldUrl(props?.blok?.link);

    if (!link) return "#";

    return link;
  });

  const onCardClick = (event) => {
    if (isEditMode === true) return;

    if (!hasCardLink.value) return;

    if (props.blok?.buttons?.length > 0 || cardLink.value == "#") return;

    if (props.blok?.link?.target == "_blank") return;

    if (props.blok?.buttons?.length === 1) {
      console.log(card.value.querySelectorAll(".masonry-card-buttons")[0]);
      card.value.querySelectorAll(".masonry-card-buttons a")[0].click();
      event.stopPropagation();
      return;
    }

    if (props.blok?.buttons?.length > 1) return;

    if (cardLink.value !== "#") window.location.assign(getLinkFieldUrl(props.blok?.link));
  };

  onMounted(() => {
    if (props.blok?.personalise) {
      const personalise = ref(props.blok?.personalise);
      visibility.value = checkPersonalisedVisibility(personalise.value);

      if (personalise.value.split(" ").includes("api") && visibility.value === true) {
        nextTick(() => {
          if (import.meta.client) {
            setTimeout(() => {
              document.querySelectorAll(".masonry-grid .masonry-card-buttons .btn-purple").forEach((btn) => {
                btn.classList.remove("btn-purple");
                btn.classList.add("btn-primary");
              });
            }, 100);
          }
        });
      }
    }
  });
</script>
